function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_422",
  "data-name": "Group 422",
  transform: "translate(0.539 0.539)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_351",
  "data-name": "Path 351",
  d: "M618.867,177.169a9.5,9.5,0,1,1-.485,2.155",
  transform: "translate(-618.33 -170.825)",
  fill: "none",
  stroke: "#a8a8a8",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.078
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_329",
  "data-name": "Group 329",
  transform: "translate(5.452 5.452)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_327",
  "data-name": "Group 327",
  transform: "translate(0.215)"
}, /*#__PURE__*/React.createElement("line", {
  id: "Line_100",
  "data-name": "Line 100",
  y1: 1.227,
  x2: 1.227,
  transform: "translate(6.438)",
  fill: "none",
  stroke: "#a8a8a8",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.078
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_101",
  "data-name": "Line 101",
  y1: 5.943,
  x2: 5.512,
  transform: "translate(0 2.153)",
  fill: "none",
  stroke: "#a8a8a8",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.078
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_328",
  "data-name": "Group 328",
  transform: "translate(0 0.215)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_352",
  "data-name": "Path 352",
  d: "M637.375,189.778l-5.943-5.512-.926-.926-1.227-1.227",
  transform: "translate(-629.279 -182.113)",
  fill: "none",
  stroke: "#a8a8a8",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.078
}))));

var SvgJoratoRemove = function SvgJoratoRemove(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20.078,
    height: 20.078,
    viewBox: "0 0 20.078 20.078",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgJoratoRemove, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/jorato-remove.990448ec.svg";
export { ForwardRef as ReactComponent };